import { getConfig } from './config'

export interface ValidatePhoneResponse {
  success: true;
}

export const request = async (): Promise<ValidatePhoneResponse> => {
  const config = getConfig()
  const response = await config.axios.post<ValidatePhoneResponse>(`${config.API_URL}/auth/verify-phone/request`, {})

  return response.data
}

export const validate = async (token: string): Promise<ValidatePhoneResponse> => {
  const config = getConfig()
  const response = await config.axios.post<ValidatePhoneResponse>(`${config.API_URL}/auth/verify-phone`, { token })

  return response.data
}
